<template>
    <div class="footer">
        <div class="container">
            <div class="row">
                <div class="col-md pl-0">
                    <div class="logos text-center text-md-left">
                        <img src="../assets/SVG/PayGate-Plus-White.svg" onclick="window.open('https://www.paygate.co.za?utm_source=web&utm_medium=link&utm_campaign=Solidarity&utm_content=footer','_blank')" alt="PayGate Plus" class="footer-logo footer-image-link">
                        <span> BY </span>
                        <img src="../assets/SVG/DPO-SA.svg" onclick="window.open('https://www.paygate.co.za?utm_source=web&utm_medium=link&utm_campaign=Solidarity&utm_content=footer','_blank')" alt="DPO South Africa" class="footer-logo h30 footer-image-link">
                        <span> in partnership with </span>
                        <img src="../assets/SVG/Absa.svg" alt="ABSA" class="footer-logo h40">
                    </div>
                </div>
                <div class="col generic-spacer d-block d-xs-block d-lg-none"></div>
                <div class="col-md text-center text-md-right">
                    <a class="footer-link" target="_blank" href="https://www.paygate.co.za/privacy-policy/?utm_source=web&utm_medium=link&utm_campaign=Solidarity&utm_content=tc">Privacy &amp; Terms</a>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="copyright">
                        <span>2020 Copyright PayGate (Pty) Ltd</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'Footer'
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    p {
        margin: 0 !important;
        padding: 0 15px;
    }

    .text-muted {
        color: grey;
        font-size: 1rem;
    }
</style>
